import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaSearch, FaTrash, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const RoboticsImageList = () => {
  const [mediaList, setMediaList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [kits, setKits] = useState([]); // In case you want to fetch kit names separately
  const [currentAction, setCurrentAction] = useState("");

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    setCurrentAction("media");
    callAPI("get", "admin/robotic-media");
  }, []);

  useEffect(() => {
    if (statusCode === 200 && currentAction === "media") {
      setMediaList(responce.data);
    }

  }, [responce, statusCode, currentAction]);

  const deleteMedia = (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this?");
    if (confirmDelete) {
      setCurrentAction("delete");
      callAPI("delete", `admin/robotic-media/${id}`);
    }
  };

  useEffect(()=>{
    
    if (statusCode === 204 && 202) {
      toast.success("Deleted successfully");
      callAPI("get", "admin/robotic-media");
    }
  },[statusCode])

  // Optional fallback for kit name (you can customize or remove if not needed)
  const getKitNameById = (id) => {
    const kit = kits.find((k) => k.id === id);
    return kit ? kit.name : "N/A";
  };

  // Filtered media based on search and type
  const filteredMedia = mediaList.filter((item) => {
    const matchesSearch = item.kit?.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = typeFilter ? item.type === typeFilter : true;
    return matchesSearch && matchesType;
  });

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Robotics Media List"
                subTitle="Manage uploaded robotics media files"
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.roboticsimage.add}>
                <button className="btn btn-primary">Add Image</button>
              </Link>
            </div>
          </div>

          <div className="card shadow-sm rounded-lg overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-4 mb-2">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by kit name"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  <select
                    className="form-select"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <option value="">Filter by type</option>
                    <option value="image">Image</option>
                    <option value="video">Video</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th>#</th>
                    <th>Preview</th>
                    <th>Type</th>
                    <th>Kit Name</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMedia.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        No media found.
                      </td>
                    </tr>
                  ) : (
                    filteredMedia.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>
                          {item.type === "image" ? (
                            <img
                              src={item.file}
                              alt="Media"
                              style={{ width: "60px", height: "60px", objectFit: "cover" }}
                              className="rounded"
                            />
                          ) : (
                            <video width="80" height="60" controls style={{ borderRadius: "5px" }}>
                              <source src={item.file} type="video/mp4" />
                              Your browser does not support video.
                            </video>
                          )}
                        </td>
                        <td>
                          <span
                            className={`badge bg-${
                              item.type === "image" ? "primary" : "success"
                            } text-capitalize`}
                          >
                            {item.type}
                          </span>
                        </td>
                        <td>{item.kit?.name || getKitNameById(item.kit_id)}</td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <Link to={uiRoutes.admin.roboticsimage.edit.replace(":id", item.id)}>
                              <button className="sys-list-table__action edit" title="Edit">
                                <FaEdit />
                              </button>
                            </Link>
                            <button
                              className="sys-list-table__action delete"
                              title="Delete"
                              onClick={() => deleteMedia(item.id)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default RoboticsImageList;
